import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Spletno nasilje",
  "description": "",
  "published": "2007-07-04T00:00:00.000Z",
  "redirect_from": ["/blog/spletno-nasilje/swizec/177"],
  "categories": "video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`OÄitno je spletno nasilje nekod po svetu postalo dovolj velik problem, da se je nekdo odloÄil posneti `}<a parentName="p" {...{
        "href": "http://www.youtube.com/watch?v=csS_RnOhd-Q"
      }}>{`nekaj`}</a>{` `}<a parentName="p" {...{
        "href": "http://www.youtube.com/watch?v=QYaWNYXpBis"
      }}>{`oglasov`}</a>{` na to temo, se pravi Äivkanje proti temu. ÄŒudim se kako je to za nekatere sploh lahko tako velik problem in zakaj so izbrali tak slogan, da opraviÄi neupoštevanje le-tega tako veliko ljudem.`}</p>
    <p>{`Bodimo natanÄnejši, slogan pravi: "ÄŒe tega ne bi rekli v resnici, zakaj potem reÄi na spletu?" in prepriÄan sem, da vas veliko vidi kje je tu problem. Prvo kot prvo predvideva, da so vsi opazovalci oglasa hipokritiÄne barabe, ki nikoli ne povedo kaj mislijo in se Äloveku raje smehljajÄkajo v obraz in ga potem zabodejo v hrbet. To je narobe. Celo tako zelo je narobe, da bi moralo postati javni problem in biti Äivkano proti. To bi lahko rešilo veliko ljudi iz prijateljstev z ljudmi, ki jih v resnici sploh ne marajo.`}</p>
    <p>{`Lahko bi se povedalo še veliko o napaÄnosti hipokritiÄnosti, ampak posvetimo se raje temi. Poglejmo zakaj je spletno nasilje sploh problem, ker preprosto ne morem odkriti razlogov. Ko ti na spletu nekdo govori stvari, ki jih noÄeš slišati lahko zapreš pogovorno okno, lahko greš na drug forum ali pa preprosto na drugo temo in lahko Äloveka celo blockaš, da ti nikoli veÄ ne more niÄ reÄi. Zakaj je torej to tak problem, ko pa imamo toliko moÅ¾nosti? Sploh pa, zakaj bi kogarkoli brigalo kaj nekdo pol sveta stran pravi in misli, ker to preprosto ni pomembno v nobenem pogledu.`}</p>
    <p>{`KonÄujem z mislijo, ki sem jo nekoÄ slišal od modre uÄiteljice matematike: "ÄŒe je resniÄno, potem ni Å¾aljivka in ne bi smelo Å¾aliti."`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      